import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const ContactForm = ({ formSubmitted, setFormSubmitted }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // إرسال البريد باستخدام EmailJS
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
      to_email: 'info.taqnya@gmail.com'
    };

    // استبدل هذه القيم بمعلومات حساب EmailJS الخاص بك
    emailjs.send(
      'YOUR_SERVICE_ID',        // Service ID
      'YOUR_TEMPLATE_ID',       // Template ID
      templateParams,
      'YOUR_PUBLIC_KEY'         // Public Key
    )
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      setFormSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    })
    .catch((err) => {
      console.error('FAILED..');
    });
  };

  return (
    <div className="contact-form-container">
      {formSubmitted ? (
        <div className="success-message">
          <h3>Thank you!</h3> 
          <p>Your message has been sent successfully. We will contact you as soon as possible.</p>
          <button 
            className="submit-btn" 
            onClick={() => setFormSubmitted(false)}
            style={{ marginTop: '20px', maxWidth: '200px' }}
          >
            Send Another Message
          </button>
        </div>
      ) : (
        <form className="contact-form" onSubmit={handleSubmit}>
          <h3>Contact Form</h3>
          <p>Fill out the form below and we'll get back to you as soon as possible.</p>
          
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Full Name *"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
          </div>
          
          <div className="form-group">
            <input
              type="text"
              name="subject"
              placeholder="Subject *"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <textarea
              name="message"
              placeholder="Your Message *"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          
          <button type="submit" className="submit-btn">
            Send Message
          </button>
        </form>
      )}
    </div>
  );
};

export default ContactForm;